import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export interface ShipmentLSPStationCodeListRequestParams {
  customerKey: number;
}

export const getShipmentLSPStationCodeListAPI = (params: ShipmentLSPStationCodeListRequestParams) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetLSPStationCodeList`,
  });
};

export type ShipmentLSPStationCodeListResponse = string[];

export const fetchShipmentLSPStationCodeList = async (
  params: ShipmentLSPStationCodeListRequestParams,
): Promise<ShipmentLSPStationCodeListResponse> => {
  const response: AxiosResponse<ShipmentLSPStationCodeListResponse> = await getShipmentLSPStationCodeListAPI(params);
  return response.data;
};
